module.exports = __webpack_public_path__ + "static/pulsio_box_with_circle-3305ec86ca757474cef8ff3378171110.png";